module.exports = __webpack_public_path__ + "static/media/sw-print-cover.43bc73bf.jpeg";